/**
 * parseISODate is used to transform dates in validation
 * schemas for input fields.
 *
 * @param value
 * @param originalValue
 * @returns A Date or null
 */
export function parseISODate(value, originalValue) {
    if (originalValue === null) {
        return value;
    }
    if (originalValue instanceof Date) {
        return originalValue;
    }
    if (originalValue.length > 0) {
        return new Date(originalValue);
    }
    return null;
}
export function createParseApiDate(apiDateToDate) {
    return (value, originalValue) => originalValue === null
        ? value
        : originalValue instanceof Date
            ? originalValue
            : apiDateToDate(originalValue);
}
